enum Permission {
  NOT_LOGIN = -1,
  NOT_GOOGLE_AUTHENTICATOR = -2,
  EVERYONE = -3
}

export default Permission
